<template>
  <b-badge :variant="variant" :id="$id('popover')">
    <b-icon :icon="icon" aria-hidden="true" :variant="iconVariant"></b-icon>
    <b-popover :target="$id('popover')" triggers="hover" placement="bottom">
      <template v-slot:title>{{title}}<slot name="title"></slot></template>
      <slot></slot>
    </b-popover>
  </b-badge>
</template>
<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class extends Vue {
  @Prop()
  public title!: string

  @Prop()
  public icon!: string

  @Prop()
  public variant!: string

  @Prop()
  public iconVariant!: string
}
</script>
<style>
</style>
